/**
 * Brand logo Quantum Planner: cascata di 4 barre decrescenti, ultima accento rosso.
 * Componibile come solo icona o icona + testo (font Outfit).
 */
export function LogoIcon({ size = 28, dark = false }) {
  const fill = dark ? '#FAFAF9' : '#171513';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 46"
      role="img"
      aria-label="Quantum Planner"
      className="shrink-0"
    >
      <rect x="6" y="9" width="34" height="5.5" rx="2.75" fill={fill} />
      <rect x="6" y="18.5" width="26" height="5.5" rx="2.75" fill={fill} />
      <rect x="6" y="28" width="18" height="5.5" rx="2.75" fill={fill} />
      <rect x="6" y="37.5" width="10" height="5.5" rx="2.75" fill="#E5484D" />
    </svg>
  );
}

export default function Logo({ size = 24, hideText = false, dark = false }) {
  return (
    <div className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <LogoIcon size={size} dark={dark} />
      {!hideText && (
        <span
          className="font-display leading-none whitespace-nowrap"
          style={{ fontSize: Math.round(size * 0.6) }}
        >
          <span style={{ fontWeight: 700, color: dark ? '#FAFAF9' : '#171513' }}>Quantum</span>
          <span style={{ fontWeight: 400, color: '#8A8A85' }}> Planner</span>
        </span>
      )}
    </div>
  );
}
